import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Spin } from "antd";
import AudioPlayer from "../audioPlayer";
import { DateRange } from "react-date-range";
import { format } from "date-fns";

type Permission = { id: number; name: string };
type Admin = {
    student_name: string;
    student_scs: string;
    agent_name: string;
    call_start_time_: string;
    call_end_time_: string;
    call_duration_hms: string;
    conversation_duration_hms: string;
    caller_status: string;
    destination_status: string;
    call_status: string;
    aws_call_recording_file: string;
};

const SummerCampAgentWiseBranchReports = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const location = useLocation();
    const {
        id,
        startDate: initialStartDate,
        endDate: initialEndDate,
    } = location.state || {};
    const data = exam;
    const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${month}-${day}-${year}`;
    const defaultValue = dayjs(formattedDate);
    const jwtToken = Cookies.get("authToken");
    const { userPermissions, webApi } = useUserPermissions();
    const [isLoading, setIsLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [admin, setAdmin] = useState<Admin[]>([]);
    const [from, setFrom] = useState();
    const [to, setTo] = useState<number>();
    const [totalCount, setTotalCount] = useState();
    const [toastMessage, setToastMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = localStorage.getItem("summerCampAgentWiseBranchReportsCurrentPage");
    return savedPage ? JSON.parse(savedPage) : 1;
  });
  useEffect(() => {
    localStorage.setItem("summerCampAgentWiseBranchReportsCurrentPage", JSON.stringify(currentPage));
  }, [currentPage]);
    const [pageSize, setPageSize] = useState<number>(() => {
        const savedPageSize = localStorage.getItem("summerCampAgentWiseBranchReportsPageSize");
        return savedPageSize ? Number(savedPageSize) : 10;
      });
    
      useEffect(() => {
        localStorage.setItem("summerCampAgentWiseBranchReportsPageSize", pageSize.toString());
      }, [pageSize]);
   const [searchText, setSearchText] = useState<string>(() => {
     return localStorage.getItem("summerCampAgentWiseBranchReportsSearchText") || "";
   });
   
   useEffect(() => {
     localStorage.setItem(
       "summerCampAgentWiseBranchReportsSearchText",
       searchText
     );
   }, [searchText]);
    const [playingAudio, setPlayingAudio] = useState<string | null>(null);
    const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});
    const [showCalendar1, setShowCalendar1] = useState(false);
    // const [startDate, setStartDate] = useState<string | null>(null);
    // const [endDate, setEndDate] = useState<string | null>(null);

    const [dateRange, setDateRange] = useState([
        {
            startDate: initialStartDate
                ? new Date(initialStartDate)
                : new Date(new Date().setHours(0, 0, 0, 0)),
            endDate: initialEndDate
                ? new Date(initialEndDate)
                : new Date(new Date().setHours(0, 0, 0, 0)),
            key: "selection",
        },
    ]);

    const startDate = format(dateRange[0].startDate, "yyyy-MM-dd");
    const endDate = format(dateRange[0].endDate, "yyyy-MM-dd");

    const handlePlayPause = (id: string) => {
        const currentAudio = audioRefs.current[id];

        if (currentAudio) {
            if (playingAudio === id) {
                currentAudio.pause();
                setPlayingAudio(null);
            } else {
                if (playingAudio !== null) {
                    const previousAudio = audioRefs.current[playingAudio];
                    if (previousAudio) {
                        previousAudio.pause();
                    }
                }
                currentAudio
                    .play()
                    .then(() => setPlayingAudio(id))
                    .catch((error) => {
                        console.error("Error playing audio:", error);
                        setPlayingAudio(null);
                    });
            }
        }
    };

    const handleFetchData = () => {
        if (startDate && endDate) {
            fetchData(id, currentPage, pageSize, searchText); // Call fetchData with date range
            // Hide the date range picker after selecting dates
            setShowCalendar1(false);
        }
    };

    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject
        );
    };

    useEffect(() => {
        if (!checkPermission("view_summer_camp_agent_report", "Records")) {
            navigate(routes.crmLandingPage);
        } else {
            fetchData(
                id,
                currentPage,
                pageSize,
                searchText,

            );
        }
    }, [userPermissions,currentPage]);

    const handleApplyClick = () => {
        if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.remove("show");
        }
    };

    const getModalContainer = () => {
        const modalElement = document.getElementById("modal-datepicker");
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    const fetchGroupsData = async (
        id: number,
        page: number,
        pageSize: number,
        searchText: string,
        startDate = "",
        endDate = ""
    ) => {
        const response = await fetch(
            `${webApi}/summercamp/summer_camp_agent_brach_wise_reports/?agent=${id}&page=${page}&page_size=${pageSize}&search=${searchText}`,
            options
        );
        if (!response.ok) {
            if (response.status === 404) {
                return await response.json();
            }
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
               navigate("/academic/sri-chaitanya/crm/landing-page");
            }
            throw new Error(errorData.detail || "Failed to fetch user data");
        }
        return await response.json();
    };

    const fetchData = async (
        id: number,
        page: number,
        pageSize: number,
        searchText: string,

    ) => {
        setIsLoading(true); // Start loading
        try {
            const [groupsData] = await Promise.all([
                fetchGroupsData(id, page, pageSize, searchText),
            ]);
            setTotalPages(groupsData.total_pages);
            setAdmin(groupsData.results);
            setTotalCount(groupsData.total_count);
            setFrom(groupsData.from);
            setTo(groupsData.to);
            setCurrentPage(groupsData.current_page_number);
            setTotalCount(groupsData.total_count);
            setToastMessage(groupsData.message || "submitted successfully!");
            setShowSuccessToast(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    useEffect(() => {
        console.log(admin);
    }, [admin])

    const handleTableChange = (pagination: any) => {
        const { current, pageSize } = pagination;
        setCurrentPage(current);
        setPageSize(pageSize);
        fetchData(
            id,
            current,
            pageSize,
            searchText,

        ); // Fetch new data based on the updated pagination
    };

    const handleSearch = (value: string) => {
        setSearchText(value);
        fetchData(
            id,
            currentPage,
            pageSize,
            value,

        );
    };

    const [loading, setLoading] = useState(false);

    const handleExportClick = async () => {

        window.location.href = `${webApi}/exports/export_summer_camp_agent_branch_wise_report/?agent=${id}&token=${jwtToken}&search=${searchText}`

    };

    const columns = [
        {
            title: "Branch",
            dataIndex: "name",
        },
        {
            title: "Unique Lead Touch",
            dataIndex: "students_connected",
        },
        {
            title: "CVR",
            dataIndex: "cvr",
        },
        {
            title: "Total Sales",
            dataIndex: "students_sales_count",
        },
        // {
        //     title: "Sales Percentage",
        //     dataIndex: "connected_students_sales_percentage",
        // },
        {
            title: "Calls",
            dataIndex: "no_of_calls",
        },
        {
            title: "Connected Calls",
            dataIndex: "no_of_calls_connected",
        },

        {
            title: "Interested",
            dataIndex: "no_of_interested",
        },
        {
            title: "Callbacks",
            dataIndex: "no_of_call_backs",
        },
        {
            title: "Less than 30 Seconds",
            dataIndex: "less_than_30_secs",
        },
        {
            title: "Less than 1 Minute",
            dataIndex: "less_than_1_min",
        },
        {
            title: "Less than 1 Min 30 Secs",
            dataIndex: "less_than_1_min_30_secs",
        },
        {
            title: "Greater than 1 Min 30 Secs",
            dataIndex: "greater_than_1_min_30_secs",
        },

        {
            title: "Not Intrested",
            dataIndex: "no_of_not_interested",
        }
    ];

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">
                                SummerCamp Agent Branch Reports
                            </h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.crmLandingPage}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={routes.SummerCampAgentReports}>Agent Reports</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        SummerCamp Agent Branch Reports
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            {checkPermission("can_export_summer_camp_agent_branch_wise_reports", "Exports") && (
                                <button className="btn btn-primary me-2" onClick={handleExportClick} disabled={loading}>
                                    {loading ? (
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : (
                                        "Export"
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                    {/* /Page Header */}
                    {/* Guardians List */}
                    <div
                        className="card "
                        style={{
                            width: "100%",
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            borderRadius: "10px",
                        }}
                    >
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                            <h4 className="mb-3">SummerCamp Agent Branch Reports</h4>
                            <div
                                className="d-flex align-items-center flex-wrap"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >

                            </div>
                        </div>
                        <div className="card-body p-0 py-3">
                            <div
                                className="serch-global text-right"
                                style={{ marginRight: "15px" }}
                            >
                                <input
                                    type="search"
                                    className="form-control form-control-sm mb-3 w-auto float-end"
                                    value={searchText}
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e.target.value)}
                                    aria-controls="DataTables_Table_0"
                                ></input>
                            </div>
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin /> {/* Display loader while loading */}
                                </div>
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={admin}
                                    Selection={false}
                                    pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        locale: { items_per_page: "" },
                                        nextIcon: <span>Next</span>,
                                        prevIcon: <span>Prev</span>,
                                        defaultPageSize: 10,
                                        showSizeChanger: true,
                                        total: totalCount,
                                        showTotal: (total: any, range: any[]) =>
                                            `${range[0]}-${range[1]} of ${total}`,
                                        pageSizeOptions: ["10", "20", "30"],
                                    }}
                                    onChange={handleTableChange} // Move this outside of pagination
                                    onSearch={handleSearch}
                                />
                            )}
                        </div>
                    </div>
                    {/* /Guardians List */}
                </div>
            </div>
            <>
                {/* Delete Modal */}
                <div className="modal fade" id="delete-modal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <form>
                                <div className="modal-body text-center">
                                    <span className="delete-icon">
                                        <i className="ti ti-trash-x" />
                                    </span>
                                    <h4>Confirm Deletion</h4>
                                    <p>
                                        You want to delete all the marked items, this cant be undone
                                        once you delete.
                                    </p>
                                    <div className="d-flex justify-content-center">
                                        <Link
                                            to="#"
                                            className="btn btn-light me-3"
                                            data-bs-dismiss="modal"
                                        >
                                            Cancel
                                        </Link>
                                        <Link
                                            to="#"
                                            data-bs-dismiss="modal"
                                            className="btn btn-danger"
                                        >
                                            Yes, Delete
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* /Delete Modal */}
            </>
        </div>
    );
};

export default SummerCampAgentWiseBranchReports;
